import type { FC } from 'react'
import React, { useState } from 'react'
import type { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { LoanProductCalc } from '@/components/composed/LoanProductCalc'
import { ELoanProductCollapsing, LOAN_PRODUCTS_HAS_ONLY_CONSULT_FORM } from './constants'
import { LoanProductConsult } from './LoanProductConsult'
import { LoanProductOrder } from './LoanProductOrder'
import type { ILoanProductCollapsingProps } from './types'
import './style.scss'

export const LoanProductCollapsing: FC<ILoanProductCollapsingProps> = props => {
  const { product, navItems } = props

  const [activeBlock, setActiveBlock] = useState(
    LOAN_PRODUCTS_HAS_ONLY_CONSULT_FORM.includes(product.productId as FundingProduct)
      ? ELoanProductCollapsing.CONSULT
      : ELoanProductCollapsing.ORDER,
  )

  const onClickOfferButton = () => setActiveBlock(ELoanProductCollapsing.ORDER)
  const onClickConsult = () => setActiveBlock(ELoanProductCollapsing.CONSULT)
  const onClickBackFromConsult = () => setActiveBlock(ELoanProductCollapsing.ORDER)

  const renderActiveBlock = () => {
    switch (activeBlock) {
      case ELoanProductCollapsing.CALC:
        return <LoanProductCalc actionOnOffer={onClickOfferButton} actionOnConsult={onClickConsult} />
      case ELoanProductCollapsing.CONSULT:
        return <LoanProductConsult navItems={navItems} onBack={onClickBackFromConsult} product={product} />
      case ELoanProductCollapsing.ORDER:
      default:
        return <LoanProductOrder product={product} setIsActiveBlock={setActiveBlock} />
    }
  }

  return <div className="loanProductCollapsing">{renderActiveBlock()}</div>
}
